import React from 'react';
import { Button } from './Button';
import useI18n from '../../hooks/useI18n';

interface RefreshButtonProps {
  onRefresh: () => void;
  isRefreshing: boolean;
  secondsRemaining: number;
  className?: string;
}

const RefreshIcon: React.FC<{ spinning: boolean }> = ({ spinning }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={spinning ? 'animate-spin' : undefined}
  >
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onRefresh,
  isRefreshing,
  secondsRemaining,
  className,
}) => {
  const { t } = useI18n();
  const disabled = isRefreshing || secondsRemaining > 0;

  const label = isRefreshing
    ? t('common.refreshing')
    : secondsRemaining > 0
      ? t('common.refreshCooldown', { seconds: secondsRemaining })
      : t('common.refresh');

  return (
    <Button
      variant="outlined"
      color="default"
      disabled={disabled}
      onClick={onRefresh}
      icon={<RefreshIcon spinning={isRefreshing} />}
      className={className}
    >
      {label}
    </Button>
  );
};

export default RefreshButton;
